import React from 'react';
import styled from 'styled-components';

import NotificationBox, { BaseProps } from './Base';

export type ComponentProps = Omit<BaseProps, 'type'> & {
  /**
   * Text to show under the title of the Notification
   */
  value?: string | JSX.Element | (string | JSX.Element)[];
};

const Text = styled.div`
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  overflow-wrap: break-word;
  letter-spacing: -0.32px;
`;

function getTextParsed(
  Element: React.ComponentType,
  value: string | JSX.Element | (string | JSX.Element)[]
) {
  if (value instanceof Array) {
    return value.map((item, i) => {
      return <Element key={`${item}_${i}`}>{item}</Element>;
    });
  }
  return <Element>{value}</Element>;
}

/**
 * General error box
 */
export const Info: React.FC<ComponentProps> = ({ value, children, ...rest }) => {
  return (
    <NotificationBox type='Info' {...rest}>
      {children || getTextParsed(Text, value || '')}
    </NotificationBox>
  );
};

export default Info;
